import { render, staticRenderFns } from "./PointResultCard.vue?vue&type=template&id=3a6d1398&scoped=true"
import script from "./PointResultCard.vue?vue&type=script&lang=js"
export * from "./PointResultCard.vue?vue&type=script&lang=js"
import style0 from "./PointResultCard.vue?vue&type=style&index=0&id=3a6d1398&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6d1398",
  null
  
)

export default component.exports